export type OrganizationLogoReplacedPayload = {
	organizationId: number;
};

export type OrganizationLogoReplacedAction = {
	type: 'ORGANIZATION_LOGO_REPLACED';
	payload: OrganizationLogoReplacedPayload;
};

export default (payload: OrganizationLogoReplacedPayload): OrganizationLogoReplacedAction => ({
	type: 'ORGANIZATION_LOGO_REPLACED',
	payload,
});
